import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "countdown", "pauseButton"]
  static values = {
    interval: { type: Number, default: 30 },
    currentPeriod: String
  }

  connect() {
    this.countdown = this.intervalValue
    this.isPaused = false
    this.controllerId = Math.random().toString(36).substr(2, 9)

    // Restore scroll position if it was saved
    const savedScrollPosition = sessionStorage.getItem('dashboard_scroll_position')
    if (savedScrollPosition) {
      const scrollY = parseInt(savedScrollPosition, 10)
      window.scrollTo(0, scrollY)
      sessionStorage.removeItem('dashboard_scroll_position')
    }

    this.startRefreshTimer()
  }

  disconnect() {
    this.clearTimer()
  }

  startRefreshTimer() {
    // Clear any existing timer first
    this.clearTimer()

    this.countdown = this.intervalValue

    this.refreshInterval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  clearTimer() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
      this.refreshInterval = null
    }
  }

  updateCountdown() {
    if (!this.isPaused) {
      this.countdown--

      if (this.hasCountdownTarget) {
        this.countdownTarget.textContent = this.countdown
      } else {
        console.warn("[DashboardRefresh] Countdown target missing!")
      }

      if (this.countdown <= 0) {
        this.showRefreshingState()
        this.refreshDashboard()
      }
    }
  }

  showRefreshingState() {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = '<div class="w-2 h-2 bg-blue-500 rounded-full animate-spin"></div>'
    }
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = 'refreshing...'
    }
  }

  refreshDashboard() {
    const period = this.currentPeriodValue || '30d'

    // Clear timer before navigation to prevent multiple instances
    this.clearTimer()

    // Preserve scroll position
    const scrollY = window.scrollY
    sessionStorage.setItem('dashboard_scroll_position', scrollY.toString())

    // Normal page reload with preserved scroll
    window.location.href = `${window.location.pathname}?period=${period}`
  }

  togglePause() {
    this.isPaused = !this.isPaused

    if (this.isPaused) {
      if (this.hasStatusTarget) {
        this.statusTarget.innerHTML = '<div class="w-2 h-2 bg-gray-400 rounded-full"></div>'
      }
      if (this.hasPauseButtonTarget) {
        this.pauseButtonTarget.textContent = 'Resume'
        this.pauseButtonTarget.classList.remove('text-gray-600')
        this.pauseButtonTarget.classList.add('text-blue-600')
      }
    } else {
      if (this.hasStatusTarget) {
        this.statusTarget.innerHTML = '<div class="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>'
      }
      if (this.hasPauseButtonTarget) {
        this.pauseButtonTarget.textContent = 'Pause'
        this.pauseButtonTarget.classList.remove('text-blue-600')
        this.pauseButtonTarget.classList.add('text-gray-600')
      }
    }
  }
}